import { DeviceUtilitiesService } from '@mitchell/react.component.ux';
export const getIsMobileView = () => !!new DeviceUtilitiesService().isMobile();
export const getIsMac = () => !!new DeviceUtilitiesService().isMac();
export const getIsIos = () => !!new DeviceUtilitiesService().isIOS();
//# sourceMappingURL=DeviceUtils.js.map